module.exports = __webpack_public_path__ + "static/media/video.da75a0b2.png";